import DarkCard from "../../../../../../components/card/DarkCard";
import LightCard from "../../../../../../components/card/LightCard";
import RedHeader from "../../../../../../components/ui/RedBgTitleHeader";
import { useTranslation } from "react-i18next";
import RatesSettings from "./RatesSettings";
import EventsSettings from "./EventsSettings";
import OtherCostsSettings from "./OtherCostsSettings";
import React, {useEffect, useRef, useState} from "react";
import { v4 as uuidv4 } from 'uuid';
import {Button} from "../../../../../../components/ui/Button";
import PopupMessage from "../../../../../../components/ui/PopupMessage";
import {useNavigate} from "react-router-dom";
import { Colors } from "../../../../../../components/theme";
import { Link } from "react-router-dom";
import useEndpoint from "../../../../../../hooks/useEndpiont";
import {popupData} from "../../../../../../helpers/dictionary/users";
import {asblSettings} from "../../../../../../services/api/endpoints";
import {TariffSelect} from "../../../../../../components/project/TariffSelect";

// const TotalPriceStyle = styled.p `
//     font-size: 1.5rem;
//     font-weight: bold;
//     width: 100%;
//     @media (max-width: 575px) {
//         font-size: 1.8rem;
//     }
// `

const newEntryValue = "-- new entry --"

function AsblSettings () {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const { makeRequest, loading, error, reset } = useEndpoint();

    const ratesField = {
        client_rate_kzm_rehearsal: {key: 'ckmzreh', name: 'client_rate_kzm_rehearsal', value: '', label: `${t("events.rehearsal")} =`},
        client_rate_kzm_raccord: {key: 'ckmzrac', name: 'client_rate_kzm_raccord', value: '', label: `${t("events.raccord")} =`},
        client_rate_kzm_concert: {key :'ckmzcon', name: 'client_rate_kzm_concert', value: '', label: `${t("events.concert")} =`},
        client_rate_mus_rehearsal: {key: 'cmusreh', name: 'client_rate_mus_rehearsal', value: '', label: `${t("events.rehearsal")} =`},
        client_rate_mus_raccord: {key: 'cmusrac', name: 'client_rate_mus_raccord', value: '', label: `${t("events.raccord")} =`},
        client_rate_mus_concert: {key: 'cmuscon', name: 'client_rate_mus_concert', value: '', label: `${t("events.concert")} =`},
        estro_rate_kzm_rehearsal: {key: 'ekmzreh', name: 'estro_rate_kzm_rehearsal', value: '', label: `${t("events.rehearsal")} =`},
        estro_rate_kzm_raccord: {key: 'ekmzrac', name: 'estro_rate_kzm_raccord', value: '', label: `${t("events.raccord")} =`},
        estro_rate_kzm_concert: {key: 'ekzmcon', name: 'estro_rate_kzm_concert', value: '', label: `${t("events.concert")} =`},
        estro_rate_mus_rehearsal: {key: 'emusreh', name: 'estro_rate_mus_rehearsal', value: '', label: `${t("events.rehearsal")} =`},
        estro_rate_mus_raccord: {key: 'emusrac', name: 'estro_rate_mus_raccord', value: '', label: `${t("events.raccord")} =`},
        estro_rate_mus_concert: {key: 'emuscon', name: 'estro_rate_mus_concert', value: '', label: `${t("events.concert")} =`},
    };

    const other_entries = {
            transport: [],
            archiving: [],
            administration: [],
    };

    const [event, setEvent] = useState({rehearsal: "", raccord: ""});
    const [rates, setRates] = useState(ratesField);
    const [otherEntries, setOtherEntries] = useState([])
    const [late_arrival_fee_deduction, setLate_arrival_fee_deduction] = useState("0.00");
    const [popup, setPopup] = useState({
        show: false,
        variant: 'error',
        title: "popups.save_data.title",
        message: "popups.save_data.message",
    });
    const [variantsOptions, setVariantsOptions] = useState([{label: newEntryValue, value: newEntryValue}])
    const [newTariff, setNewTariff] = useState({label: newEntryValue, value: newEntryValue})
    const tariffNameRef = useRef();

    const transEntry = (val) => {
        switch (val) {
            case 'Musicians':
                return val // t("transport.musicians_title")
            case 'Bow strokes 1h':
                return t("archiving.asbl_settings.bowStrokes_entry_title")
            case '1 Copy':
                return t("archiving.asbl_settings.copy_entry_title")
            case 'Filling 1h':
                return t("archiving.asbl_settings.filling_entry_title")
            case 'Operating costs':
                return t("administration.operating_costs_title")
            case 'Treasurer':
                return t("administration.treasurer_title")
            default:
                return val;
        }
    }

    const settingsItem = (el) => {
        return {
            key: el.id,
            description: transEntry(el.description),
            client_cost: el.client_cost,
            estro_cost: el.estro_cost,
            readOnly: el.readOnly,
            display_type: el.display_type,
        }
    }

    useEffect(() => {   // initail values
        const get_settings = async () => {
            try {
                const [listName, settingsResp] = await Promise.all([
                    makeRequest(asblSettings.abslSaveSettingsListName, "GET", null),
                    makeRequest(asblSettings.asblSettingsByName(newTariff.value), "GET", null)
                ]);
                    setVariantsOptions(listName);
                setEvent({
                    rehearsal: settingsResp.rehearsal_duration,
                    raccord: settingsResp.raccord_duration,
                    min_raccord_duration: settingsResp.min_raccord_duration,
                    break_after_raccord_duration: settingsResp.break_after_raccord_duration,
                });
                ratesField.client_rate_kzm_rehearsal.value = settingsResp.client_rate_kzm_rehearsal;
                ratesField.client_rate_kzm_raccord.value = settingsResp.client_rate_kzm_raccord;
                ratesField.client_rate_kzm_concert.value = settingsResp.client_rate_kzm_concert;
                ratesField.client_rate_mus_rehearsal.value = settingsResp.client_rate_mus_rehearsal;
                ratesField.client_rate_mus_raccord.value = settingsResp.client_rate_mus_raccord;
                ratesField.client_rate_mus_concert.value = settingsResp.client_rate_mus_concert;
                ratesField.estro_rate_kzm_rehearsal.value = settingsResp.estro_rate_kzm_rehearsal;
                ratesField.estro_rate_kzm_raccord.value = settingsResp.estro_rate_kzm_raccord;
                ratesField.estro_rate_kzm_concert.value = settingsResp.estro_rate_kzm_concert;
                ratesField.estro_rate_mus_rehearsal.value = settingsResp.estro_rate_mus_rehearsal;
                ratesField.estro_rate_mus_raccord.value = settingsResp.estro_rate_mus_raccord;
                ratesField.estro_rate_mus_concert.value = settingsResp.estro_rate_mus_concert;
                ratesField.id = settingsResp.id
                setRates(ratesField);
                settingsResp.other_cost_type.map( el => {
                    switch (el.cost_type) {
                        case 'transport':
                            other_entries.transport.push(settingsItem(el))
                            break;
                        case 'archiving':
                            other_entries.archiving.push(settingsItem(el))
                            break;
                        case 'administration':
                            other_entries.administration.push(settingsItem(el));
                            break;
                        default:
                            return {}
                    }
                })
                setOtherEntries(other_entries)
                setLate_arrival_fee_deduction(settingsResp.late_arrival_fee_deduction)
                } catch (error) {
                console.error('❌ Error:', error);
                }
        }
        get_settings();
        tariffNameRef.current?.focus();
        return () => reset()
    }, [newTariff.value, makeRequest, reset]);

    if (loading) {
        return <div><p> {t('common.loading_data')} </p></div>;
    }

    if (error) {
        return (
            <div>
                <p>{t('system_messages.error_occured')} ' ' {error.message}</p>
                <button onClick={() => window.location.reload()}>
                    {t('common.button.try_again')}
                </button>
            </div>
        );
    }

    const changeUnitInfo = (itemObj, itemType) => { // itemType = 'transport'
        const elementItemType = structuredClone(otherEntries[itemType]);

        function withOutElement(el) {
            if (el.key === itemObj.key ) {
                return true
            }
            return false
        };
        const newElementIndex = elementItemType.findIndex(withOutElement);
        elementItemType.splice(newElementIndex, 1, itemObj)

        const newEntry = {
            ...otherEntries,
            [itemType]: elementItemType
        }

        setOtherEntries(newEntry)
    };

    const addMoreHandler = (unitType) => {
        const newItem = {
            key: uuidv4(),
            description: '',
            client_cost: '0.00',
            estro_cost: '0.00',
            readOnly: false,
            display_type: "without"
        };
        const newArrayElement = otherEntries[unitType];
        newArrayElement.push(newItem)

        const newEntry = {
            ...otherEntries,
            [unitType]: newArrayElement
        }
        setOtherEntries(newEntry)
    };

    const handlePopup = (obj) => {
        setPopup(obj.show);
        if (obj.decision) {
            navigate('/asbl/settings')
        }
    }

    const saveHandler = async () => {
        const newSettingsName = tariffNameRef.current?.value
        if (newTariff.value === newEntryValue && newSettingsName.length === 0) return // trzeba wpisac nazwe

        const data = {other_cost_type: []};

        Object.entries(rates).forEach(([key, val]) => {
            data[key] = val.value
        });

        Object.entries(event).forEach(([key, val]) => {
            // zamiana nazwy klucza na taki jak w backend
            if (key === 'rehearsal') data.rehearsal_duration = val
            else if (key === 'raccord') data.raccord_duration = val
            else data[key] = val
        })

        const types = Object.keys(otherEntries)

        types.forEach((el) => {
            otherEntries[el].forEach((obj) => {
                const cost_data = {
                    description: obj.description,
                    client_cost: obj.client_cost,
                    estro_cost: obj.estro_cost,
                    cost_type: el,
                    readOnly: obj.readOnly,
                    display_type: obj.display_type,
                }
                if (newTariff.value !== newEntryValue)  cost_data["id"] = obj.key
                data['other_cost_type'].push(cost_data)
            })
        })

        data['late_arrival_fee_deduction'] = late_arrival_fee_deduction
        data['name'] = newTariff.value === newEntryValue ? newSettingsName : newTariff.value

        if (newTariff.value === newEntryValue) { // tworzenie nowej taryfy
            await makeRequest(asblSettings.abslSaveNewSettings, "POST", data)
            setPopup(error ? popupData.saveError : popupData.saveOK);

            setNewTariff({label: newSettingsName, value: newSettingsName})
        } else if (rates.id > 0) { // aktualizacja taryfy
            const payload = {
                ...data,
                other_cost_type: data.other_cost_type.map((cost) => {
                    // Jeśli id wygląda jak UUID → usuń je
                    if (typeof cost.id === "string" && /^[0-9a-fA-F-]{36}$/.test(cost.id)) {
                        const { id, ...rest } = cost;
                        return rest;
                    }
                    return cost;
                }),
            };

            await makeRequest(asblSettings.abslSaveUpdateSettings(rates.id), "PUT", payload)
            setPopup(error ? popupData.saveError : popupData.saveOK);
        }
    };

    const removeItem = (itemKey, unitType) => {
        // usun z otherEntries z unitType wpis z key=itemKey
        const entryClone = structuredClone(otherEntries)
        const indexDel =entryClone[unitType].findIndex(el => el.key === itemKey)
        entryClone[unitType].splice(indexDel, 1)
        setOtherEntries(entryClone)
    };

    const changeHandler = (val) => {
        setLate_arrival_fee_deduction(val)
    }

    const onChangeTariff = (val) => {
        setNewTariff(val)
    }

    return (
        popup.show
        ? <PopupMessage
                setPopup={handlePopup}
                variant={popup.variant}
                title={t(popup.title)}
                message={t(popup.message)}
                okBtn={t("common.button.ok")}
            />
        :<>
            <DarkCard classNames='mb-3 row'>
                <p className="m-0 p-0 breadcrumbs">
                    <span className="txt">{t("menu.asbl",{ ns: 'menu' })}</span>&#8201;&#9656;&#8201;
                    <Link to={'/asbl/settings'} className="edit-link">{t("menu.calc_settings",{ ns: 'menu' })}</Link>
                </p>
            </DarkCard>
            <DarkCard classNames='mb-3 row'>

                <TariffSelect
                    newTariff={newTariff}
                    optList={variantsOptions}
                    onChangeTariff={val => onChangeTariff(val)}
                >
                    {newTariff.value === newEntryValue && (<> <br/>{t("asbl.calc_settings.new_tarif_name")} <input type="text" ref={tariffNameRef} /> </>)}
                </TariffSelect>

                <LightCard classNames='mb-3'>
                    <RedHeader title={t("asbl.calc_settings.time_values_title")}/>
                    
                    {/* Reh., Racc., min. Warm-up, Break */}
                    <EventsSettings event={event} setEvent={setEvent}/>
                    
                    {/* Late arrival reduction */}
                    <div className="col-12 px-2">
                        <div className="d-flex flex-row align-items-center my-1">
                            <div>
                                <span>{t("asbl.calc_settings.late_arrival_reduction")}</span> =
                            </div>
                            <div className="ms-3">
                                <input
                                    value={late_arrival_fee_deduction}
                                    onChange={val => changeHandler(val.target.value)}
                                    style={{width: '100%', maxWidth: '83px', textAlign:'right'}}
                                    name='events.late_arrival_fee_deduction'
                                /> €
                            </div>
                        </div>
                    </div>
                </LightCard>

                <LightCard classNames='mb-3'>
                    {/* Musicans rates, client and estro */}
                    <RatesSettings rates={rates} setRates={setRates}/>
                </LightCard>

                <LightCard classNames='mb-3'>
                    {/* Transport and Archiving */}
                    <div className="row">
                        <div className="col-xl-6">
                            <RedHeader title={t("transport.title")}/>
                            <OtherCostsSettings
                                otherEntries={otherEntries.transport}
                                changeUnitInfo={changeUnitInfo}
                                addMoreHandler={addMoreHandler}
                                unitType={'transport'}
                                removeItem={removeItem}
                            />
                        </div>
                        <div className="col-xl-6 mt-2 mt-xl-0">
                            <RedHeader title={t("archiving.title")} />
                            <OtherCostsSettings
                                otherEntries={otherEntries.archiving}
                                changeUnitInfo={changeUnitInfo}
                                addMoreHandler={addMoreHandler}
                                unitType={'archiving'}
                                removeItem={removeItem}
                            />
                        </div>
                    </div>
                </LightCard>

                <LightCard classNames='mb-3'>
                    {/* Administration */}
                    <div className="row">
                        <div className="col-xl-6">
                            <RedHeader title={t("administration.title")} />
                            <OtherCostsSettings
                                otherEntries={otherEntries.administration}
                                changeUnitInfo={changeUnitInfo}
                                addMoreHandler={addMoreHandler}
                                unitType={'administration'}
                                removeItem={removeItem}
                            />
                        </div>
                    </div>
                </LightCard>
                <LightCard classNames='mb-3'>
                    <div className="row">
                        <div className="col-12">
                            <Button
                                variant="round"
                                style={{backgroundColor:`${Colors.green}`}}
                                type='submit'
                                onClick={saveHandler}>
                                {t("common.button.save")}
                            </Button>
                        </div>
                    </div>
                </LightCard>
            </DarkCard>
        </>
    )
}

export default AsblSettings;
